import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../AuthContext';
import "./Main.css";
import Rules from "../Rules/Rules";
import Home from "../Home/Home";
import Abilities from "../Cardetails/Ability";
import Counter from "../Counter/Counter";
import Dashboard from "../User/Dashboard";
import LoginForm from "../User/LoginForm";
import RegistrationForm from '../User/RegistrationForm';
import VideoLauncher from "../VideoLauncher";
import Cookies from "js-cookie";
import axios from "axios";
// BrowserView/MobileView not needed in this Main component
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBoxesStacked,
    faBook,
    faHome,
    faClone,
  faList,
    faUser
} from "@fortawesome/free-solid-svg-icons";
import { faEmpire } from "@fortawesome/free-brands-svg-icons";
import Index from "../Index/Index";
import PublicDeckList from "../User/PublicDeckList";
import VersionBadge from '../VersionBadge/VersionBadge';




const Main = () => {
    const { userIsLoggedIn, setUserIsLoggedIn, setShowFilter , host, port, user, setUser } = useAuth();
    const [showIndex, setShowIndex] = useState(false);
    const [showDecks, setShowDecks] = useState(false);
    const [showCards, setShowCards] = useState(true);
    const [showCounter, setShowCounter] = useState(false);
    const [showDashboard, setShowDashboard] = useState(false);
    const [showDeckBuilder, setShowDeckBuilder] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [cardsData, setCardsData] = useState({
        cards: [],
        abilities: [],
    });
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
    const [showAbilities, setShowAbilities] = useState(false);
    const [showAbilitiesPage, setShowAbilitiesPage] = useState(false);

    const [decksData, setDecksData] = useState([]);
    const [showRegistrationForm, setShowRegistrationForm] = useState(false);
    const [isVideoComplete, setIsVideoComplete] = useState(false);
  const [key, setKey] = useState(0); // Clé pour forcer le rechargement
  const [indexInitialShowCards, setIndexInitialShowCards] = useState(true);
    const [deckListKey, setDeckListKey] = useState(0);
    const [dashboardKey, setDashboardKey] = useState(0);
    const [deckKey, setDeckKey] = useState(0); // Clé pour forcer le rechargement
    const isBrowserView = typeof window !== "undefined" && !window.navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|IEMobile)/);

    const verifyToken = async (token) => {
        try {
            const response = await axios.post(`https://${host}:${port}/verify-token`, { token });

            if (response.status === 200) {
                //console.log('Token verified: User is logged in.');
                setUserIsLoggedIn(true);
                const loggedInUser = response.data.decoded.user; // Utilisez les données décodées du token pour l'utilisateur
                //console.log(response.data.decoded)
                //console.log(Cookies.get('logToken'))
                setUser(loggedInUser);
            } else {
                //console.log('Token verification failed: User is not logged in.');
                setUserIsLoggedIn(false); // Utilisateur non connecté
                // Effacer le token du localStorage si la vérification échoue
                Cookies.remove('logToken');
            }
        } catch (error) {
            console.error('Error verifying token:', error);
        }
    };



    const handleVideoEnd = () => {
    setIsVideoComplete(true);
    };

    const handleShowRegistrationForm = () => {
        setShowRegistrationForm(true);
    };

    const handleShowLoginForm = () => {
        setShowLogin(true);
        setShowRegistrationForm(false);
    };


    useEffect(() => {
        /*const checkDeviceType = () => {
            const windowWidth = window.innerWidth;
            if (windowWidth <= 768) {
                setIsVideoComplete(false); // Pour les appareils mobiles et tablettes
            } else {
                setIsVideoComplete(true); // Pour les navigateurs de bureau
            }
        };

        // Écoutez les changements de taille de la fenêtre pour détecter le changement de type d'appareil
        window.addEventListener('resize', checkDeviceType);

        // Vérifiez le type d'appareil au chargement initial de la page
        checkDeviceType();

        // Nettoyez l'écouteur d'événement lorsque le composant est démonté
        return () => {
            window.removeEventListener('resize', checkDeviceType);
        };*/

        const logToken = Cookies.get('logToken');
        if (logToken) {
            verifyToken(logToken)
        }

        fetch(`https://${host}:${port}/cards`)
            .then((response) => response.json())
            .then((data) => {
                setCardsData({
                    cards: data.cards,
                    abilities: data.abilities,
                    editions: data.editions,
                    types: data.types,
                    subtypes: data.subtypes,
                    rarities: data.rarities
                });
            })
            .catch((error) => console.error(error));

        fetch(`https://${host}:${port}/decks`)
            .then((response) => response.json())
            .then((data) => {
                //console.log(data)
                setDecksData(data);
            })
            .catch((error) => console.error(error));
    }, []);

    const summoners = cardsData.cards.filter(card => card.types.includes('Summoner'));

    const gameData = cardsData

    const handleDecksClick = () => {
      setShowAbilitiesPage(false);
        setShowDecks(true);
        setShowIndex(false);
        setShowRules(false);
        setShowCounter(false);
        setShowDashboard(false);
        setShowLogin(false);
        setShowDeckBuilder(false);
        setShowFilter(false);
        setDeckListKey(prevKey => prevKey + 1);
    };

    const handleIndexClick = (initialShowCards = true) => {
      // initialShowCards: true => show Cards view, false => show Abilities view
      setIndexInitialShowCards(Boolean(initialShowCards));
      setShowAbilitiesPage(false);
      setShowIndex(true);
      setShowAbilities(false);
      setShowRules(false);
      setShowDecks(false);
      setShowCounter(false);
      setShowDashboard(false);
      setShowLogin(false);
      setShowDeckBuilder(false);
      setShowFilter(false);
      setKey(prevKey => prevKey + 1);
      setShowDropdown(false);
    };

  const handleToggleView = () => {
        handleAbilitiesClick();
        setShowCards(false);
    };

  const handleAbilitiesClick = () => {
  setShowAbilitiesPage(true);
  setShowIndex(false);
  setShowDecks(false);
  setShowCounter(false);
  setShowDashboard(false);
  setShowLogin(false);
  setShowDeckBuilder(false);
  setShowFilter(false);
  setKey(prevKey => prevKey + 1);
  setShowDropdown(false);
};

    const handleCounterClick = () => {
      setShowAbilitiesPage(false);
        setShowIndex(false);
        setShowDecks(false);
        setShowRules(false);
        setShowCounter(true);
        setShowDashboard(false);
        setShowLogin(false);
        setShowDeckBuilder(false);
        setShowFilter(false);
    };

    const handleDashboardClick = () => {
      setShowAbilitiesPage(false);
        setShowIndex(false);
        setShowDecks(false);
        setShowRules(false);
        setShowCounter(false);
        setShowDashboard(true);
        setShowLogin(false);
        setShowDeckBuilder(false);
        setShowFilter(false);
        setDashboardKey(prevKey => prevKey + 1);
    };

  useEffect(() => {
    // Update the states based on userIsLoggedIn
    if (userIsLoggedIn) {
      setShowRegistrationForm(false);
      // If the login form is currently shown, assume the user just logged in
      // and navigate to the Dashboard automatically. If the token was
      // verified on page load (showLogin === false) keep the Index as the default.
      if (showLogin) {
        setShowLogin(false);
        setShowIndex(false);
        setShowDecks(false);
        setShowRules(false);
        setShowCounter(false);
        setShowDeckBuilder(false);
        setShowFilter(false);
        // Ensure the video/intro overlay is hidden so the dashboard is visible
        setIsVideoComplete(true);
        setShowDashboard(true);
        setDashboardKey(prevKey => prevKey + 1);
      }
    }
  }, [userIsLoggedIn, showLogin]);

  const [showRules, setShowRules] = useState(false);
  const navRef = useRef(null);

  // Keep a CSS variable --navbar-height in sync with the actual navbar height
  useEffect(() => {
    const navEl = navRef.current || document.querySelector('nav.navbar');
    if (!navEl || typeof window === 'undefined') return;
    const setNavHeight = () => {
      const h = navEl.offsetHeight || 64;
      try { document.documentElement.style.setProperty('--navbar-height', h + 'px'); } catch(e){}
    };
    setNavHeight();
    let ro = null;
    try {
      ro = new ResizeObserver(setNavHeight);
      ro.observe(navEl);
    } catch(e) {
      window.addEventListener('resize', setNavHeight);
    }
    return () => {
      try { if (ro) ro.disconnect(); } catch(e){}
      try { window.removeEventListener('resize', setNavHeight); } catch(e){}
    };
  }, [navRef.current]);

    const handleRulesClick = () => {
      setShowAbilitiesPage(false);
        setShowRules(true);
        setShowIndex(false);
        setShowDecks(false);
        setShowCounter(false);
        setShowDashboard(false);
        setShowLogin(false);
        setShowDeckBuilder(false);
        setShowFilter(false);
    };

    const handleLoginClick = () => {
      setShowAbilitiesPage(false);
        setShowIndex(false);
        setShowDecks(false);
        setShowRules(false);
        setShowCounter(false);
        setShowDashboard(false);
        setShowLogin(true);
        setShowRegistrationForm(false);
        setShowDeckBuilder(false);
        setShowFilter(false);
    };

    useEffect(() => {
        //console.log(decksData)
    }, []);

    useEffect(() => {
        setShowIndex(true);
    }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleOutsideClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [dropdownRef]);


    return (
  <div className='app-container'>
    {showDecks && (
      <PublicDeckList 
        key={deckListKey} 
        cardsData={cardsData} 
        gameData={gameData} 
        publicDecks={decksData}
      />
    )}
    {showCounter && <Counter summoners={summoners}/>}
    {showRules && <Rules />}
    {userIsLoggedIn && (showDashboard ? (
      <Dashboard 
        key={dashboardKey} 
        userIsLoggedIn={userIsLoggedIn} 
        cardsData={cardsData}
        abilities={cardsData.abilities} 
        gameData={gameData} 
        publicDecks={decksData}
        onOpenIndex={handleIndexClick}
      />
    ) : null)}
    {showLogin && (
      <div>
        {showRegistrationForm ? (
          <RegistrationForm handleShowLoginForm={handleShowLoginForm}/>
        ) : (
          <LoginForm handleShowRegistrationForm={handleShowRegistrationForm}/>
        )}
      </div>
    )}

    {!isVideoComplete ? (
      <>
        <VideoLauncher 
          onVideoEnd={handleVideoEnd}
          canSkip={Boolean(cardsData && cardsData.abilities && gameData)}
        />
      </>
    ) : (
      <div>
        <>
        {showIndex && (
          <Index 
            key={key} 
            cardsData={cardsData} 
            abilities={cardsData.abilities} 
            collectionView={false}
            initialShowCards={indexInitialShowCards}
          />
        )}

        {showAbilitiesPage && (
          <Abilities 
            key={key}
            abilities={cardsData.abilities}
          />
        )}

        <nav 
          ref={navRef}
          className="navbar navbar-expand-lg main-navbar" 
          style={{position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999}}
        >
          <button className="btn d-flex flex-column align-items-center text-light"
                  onClick={handleDecksClick}>
            <FontAwesomeIcon className="fa-home" icon={faBoxesStacked}/>
            Decks
          </button>

          <div className="btn d-flex flex-column align-items-center text-light dropup" ref={dropdownRef}>
            <button 
              className="btn d-flex flex-column align-items-center text-light dropdown-toggle"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <FontAwesomeIcon icon={faList}/>
              Index
            </button>

            {showDropdown && (
              <div className="dropdown-menu show" style={{bottom: "100%", top: "auto"}}>
                <button className="dropdown-item" onClick={() => handleIndexClick(true)}>
                  <FontAwesomeIcon icon={faClone}/> Cards
                </button>
                <button className="dropdown-item" onClick={() => handleIndexClick(false)}>
                  <FontAwesomeIcon icon={faEmpire}/> Abilities
                </button>
              </div>
            )}
          </div>

          {Cookies.get("logToken") ? (
            <button
              className="btn d-flex flex-column align-items-center text-light"
              onClick={handleDashboardClick}>
              <FontAwesomeIcon className="fa-home" icon={faHome}/>
              Dashboard
            </button>
          ) : (
            <button
              className="btn d-flex flex-column align-items-center text-light"
              onClick={handleLoginClick}>
              <FontAwesomeIcon className="fa-user" icon={faUser}/>
              Login
            </button>
          )}

          <button className="btn d-flex flex-column align-items-center text-light"
                  onClick={handleRulesClick}>
            <FontAwesomeIcon className="fa-list" icon={faBook}/>
            Rules
          </button>

          {/* Removed the disabled Abilities/Counter button per request */}
  </nav>
  </>
      </div>
    )}
    <VersionBadge />
  </div>
);

};

export default Main;

